import React from 'react'
import { businessUrl } from 'frontend_core/dist/helpers/url'
import { amplitudeLogEvent } from 'helpers/amplitude'

export default () => {
  return (
    <div className="signup-box signup-box__biz-account">
      <div className="row">
        <div className="col-md-5 col-sm-12">
          <h2 className="signup-box__title">
            ご利用料金を請求書で一括精算できる
            <br />
            法人会員のご登録はこちら
            <span className="signup-box__biz-account-free">(無料)</span>
          </h2>
        </div>
        <div className="col-md-1 col-sm-12 signup-box__biz-arrw sm-hide">
          <i className="fas fa-angle-right" />
        </div>
        <div className="col-md-6 col-sm-12 signup-box__biz-btn">
          <a
            href={businessUrl('')}
            className="button-blue pt15 pb15 w100pa sm-w100"
            onClick={() => {
              amplitudeLogEvent('Select Entry Business Account')
            }}
          >
            法人アカウント登録
          </a>
        </div>
      </div>
    </div>
  )
}
